import { Constants } from "../../../assets/utils/lib/constants";
import Drawer from "../../../assets/vfx/drawer/drawer";
import Form from "../../../assets/vfx/form/form";
import { CommunityDevelopmentReplyDto } from "../../../services/dto";
import * as yup from "yup";
import React from "react";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../../assets/utils/lib";

interface CommunityDevelopmentReplyFormProps {
    data?: CommunityDevelopmentReplyDto | undefined;
    show: boolean;
    onHide: () => void;
    onSave: (values: CommunityDevelopmentReplyDto) => DrawerFormSaveResult;
}

const validationSchema = yup.object().shape({
    message: yup.string().required("Message is required"),

});

export const CommunityDevelopmentReplyForm = (props: CommunityDevelopmentReplyFormProps) => {
    let title: string =  "Reply";
    const onSubmit = (data: CommunityDevelopmentReplyDto) => {
        data.communityDevelopmentId = props.data?.communityDevelopmentId ?? Constants.emptyGuid;
        return Promise.resolve(props.onSave(data)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
    };

    const isNew = !props.data?.id || props.data?.id === Constants.emptyGuid;
    const isLoading = props.show && !isNew && !props.data;
    return (
        <Drawer.Form
            className="w-30"
            show={props.show}
            backdrop={true}
            placement="end"
            scroll={true}
            onHide={props.onHide}
            title={title}
            initialValues={props.data ?? {}}
            validationSchema={validationSchema}
            on_Submit={onSubmit}
        >

            <Form.TextArea
                name="message"
                rows={3}
                label="Message"
                isLoading={isLoading}
            />
        </Drawer.Form>
    );
}

